module.exports = [
  "aa",
  "af",
  "ak",
  "sq",
  "an",
  "ae",
  "ay",
  "az",
  "bm",
  "eu",
  "bi",
  "bs",
  "br",
  "ca",
  "ch",
  "ny",
  "kw",
  "co",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "eo",
  "et",
  "ee",
  "fo",
  "fj",
  "fi",
  "fr",
  "ff",
  "gl",
  "de",
  "gn",
  "ht",
  "hz",
  "ho",
  "hu",
  "ia",
  "id",
  "ie",
  "ga",
  "ig",
  "ik",
  "io",
  "is",
  "it",
  "kl",
  "kr",
  "ki",
  "rw",
  "kg",
  "ku",
  "kj",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lt",
  "lu",
  "lv",
  "gv",
  "mg",
  "ms",
  "mt",
  "mi",
  "mh",
  "na",
  "nv",
  "nd",
  "ng",
  "nb",
  "nn",
  "no",
  "ii",
  "nr",
  "oc",
  "om",
  "pl",
  "pt",
  "qu",
  "rm",
  "rn",
  "rc",
  "ro",
  "sc",
  "se",
  "sm",
  "sg",
  "gd",
  "sn",
  "sk",
  "sl",
  "so",
  "st",
  "es",
  "su",
  "sw",
  "ss",
  "sv",
  "tg",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ve",
  "vi",
  "vo",
  "wa",
  "cy",
  "wo",
  "fy",
  "xh",
  "yo",
  "za",
  "zu"
]
